// extracted by mini-css-extract-plugin
export default {"companyContainer":"Company_companyContainer__aq+vt","company":"Company_company__E-1Mf","create":"Company_create__8tLJP"};